export const baseURL = '/companies';

export const settings = {
  resultsPerPage: 25,
  defaultOrderBy: 'name',
  defaultOrder: 1 // 1=asc 0=desc
};
